import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import R from 'ramda'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine } from 'recharts'
import DailyAttendanceActions from '../../Data/Redux/DailyAttendanceRedux'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

class Attendance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getDailyAttendance } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'attendance/daily')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'attendance/daily')
      }
    } else {
      getDailyAttendance()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const data = []
    const { attendance, centersInfo } = nextProps
    if (attendance.attendance) {
      Object.keys(attendance.attendance).map((att) => {
        const item = { date: att, formatDay: moment(att).format('MMM DD') }
        Object.keys(attendance.attendance[att]).map((key) => {
          if (key === 'enrolled') {
          item['Ocupación'] = attendance.attendance[att][key]
          }
          item['Asistencia'] = attendance.attendance[att][key]
        })
        data.push(item)
      })
      this.setState({ data })
    }
    if (!R.isEmpty(centersInfo)) {
      Object.keys(centersInfo.attendance).map((att) => {
        const item = { date: att, formatDay: moment(att).format('MMM DD') }
        Object.keys(centersInfo.attendance[att]).map((key) => {
          if (key === 'enrolled') {
          item['Ocupación'] = centersInfo.attendance[att][key]
          }
          item['Asistencia'] = centersInfo.attendance[att][key]
        })
        data.push(item)
      })
      this.setState({ data })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('attendance/daily', this.props.activeCenter)
    } else {
      this.props.getDailyAttendanceExcel()
    }
  }


  render() {
    const { attendance, centersInfo, fromCenter } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Asistencia Real vs Ocupación Diaria"
        date={((attendance.attendance || centersInfo) && data[0]) &&
          { initial: data[0].date, end: data[data.length - 1].date }}
        onClick={this.download}
        loading={!data[0]}
      >
        {data[0] &&
          <AreaChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="formatDay" />
            <YAxis />
            <Tooltip />
            <Legend content={<CustomizedLegend />} />
            <ReferenceLine y={attendance.capacity || centersInfo.capacity} label={"Capacidad Maxima: " + (attendance.capacity || centersInfo.capacity)} stroke="red"/>
            <Area type="monotone" dataKey="Asistencia" stroke="#bb4ab7" fill="#bb4ab7" />
            <Area type="monotone" dataKey="Ocupación" stroke="#2A517F" fill="#2A517F" />
          </AreaChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ dailyAttendance, centersInfo }) => ({
  attendance: dailyAttendance.get.results,
  centersInfo: centersInfo.daily.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getDailyAttendance: () => dispatch(DailyAttendanceActions.getRequest({}, true)),
  getDailyAttendanceExcel: () => dispatch(DailyAttendanceActions.DailyAttendanceExcelRequest()),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Attendance))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Attendance.jsx